import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';

import info from '../../../icons/info';

import store from '../../store';

import {staggeredReveal} from '../../css/styleSets';

@customElement('list-select')
export class ListSelect extends connect(store)(LitElement) {

	@property({type: Object})
	title = {
		de: '[Titel]',
		en: '[Title]',
		fr: '[Title]'
	};

	@property({type: Array})
	options = [];

	@property({type: Function})
	selected = null;

	@property({type: Function})
	canBeSelected = () => true;

	@property({type: Function})
	isSatisfied = null;

	@property({type: String})
	action = '';

	@property({type: Function})
	callback = null;

	@property({type: Boolean})
	hideDisabled = false

	@property({type: Function})
	isVisible = () => true;

	@property({type: Boolean})
	noWrap = false

	static styles = [
		staggeredReveal,
		css`
			:host {
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.info {
				color: var(--color-widget-infoicon);
				background-color: transparent;
				cursor: pointer;
				transition: background-color 0.4s, color 0.4s;
				border: none;
				padding: 0;
			}

			.info:hover {
				color: var(--color-widget-text);
			}

			.info svg path {
				fill: currentColor;
				stroke: currentColor;
			}

			.info svg circle {
				stroke: currentColor;
			}

			.values {
				display: flex;
				flex-flow: wrap;
			}

			.values.noWrap {
				display: flex;
				flex-direction: column;
			}

			.values.notSatisfied {
				border-left-color: var(--color-warn);
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.loggedIn = state.userProfile.data.loggedIn;
	}

	render() {

		const s = store.getState();
		if (!this.isVisible(s)) return null;
		return html`
			<div>
				<div class="title">
					${this.title[this.lang]}
				</div>
				<div class="values ${classMap({notSatisfied: !this.isSatisfied(s), noWrap: this.noWrap})}">
					${repeat([...this.options],
						(option) => option.id,
						(option) => html`
							${when(!option.requireLogin || (option.requireLogin && this.loggedIn), () => html`
									<list-select-item .option=${option}
													  .canBeSelected=${this.canBeSelected(s, option.id)}
													  selected=${this.selected(s)}
													  .hideDisabled=${this.hideDisabled}
													  .callback=${this.callback}
													  action="${this.action}"></list-select-item>`,
								() => null
							)}
						`)}
				</div>
			</div>

		`;
	}
}
